/**
 * Simple view for editing a shop section
 */

var _ = require('underscore');
var $ = require('js/sw-jquery/sw-jquery');
var SW = require('js/lib/sw');
var ShapewaysView = require('./ShapewaysView');
var shopSectionTemplate = require('rrTags/shop/templates/tpl.shop-section-edit.mustache');

var ShopSectionEditView = ShapewaysView.extend({

  events: function events() {
    var eventHandlers = {};

    eventHandlers['click ' + this.swSelectors.addButton] = 'onAdd';
    eventHandlers['keypress ' + this.swSelectors.addInput] = 'onAdd';
    eventHandlers['click ' + this.swSelectors.deleteButtons] = 'onDelete';

    return eventHandlers;
  },

  swAttrs: {
    sectionItemsContainer:  'data-sw-shop-section-edit-items-container',
    sectionItems:           'data-sw-shop-section-edit-item',
    sectionItemTitles:      'data-sw-shop-section-edit-item-title',
    sectionItemIds:         'data-sw-shop-section-edit-item-id',
    sectionItemsActive:     'data-sw-shop-section-edit-item-active',
    addInput:               'data-sw-shop-section-edit-add-input',
    addButton:              'data-sw-shop-section-edit-add',
    deleteButtons:          'data-sw-shop-section-edit-delete'
  },

  initialize: function() {
    var shopSections = this.getSectionArray();

    //clear out the previous list, so the change event triggers properly
    this.state.unset( 'shopSections', { silent: true } );

    this.state.set({
      shopSections: shopSections
    });


    this.listenTo(this.state, 'change', this.repaint, this);
  },

  getSectionArray: function() {
    var shopSections = [];

    var self = this;

    $(this.swSelectors.sectionItems).each(function(){
      var sectionTitle = $(this).find(self.swSelectors.sectionItemTitles).val();
      var sectionId = $(this).find(self.swSelectors.sectionItemIds).val();
      var isActive = $(this).find(self.swSelectors.sectionItemsActive).val();

      shopSections.push({
        sectionTitle:   sectionTitle,
        sectionId:      sectionId,
        isActive:       isActive
      });
    });

    return shopSections;
  },

  onAdd: function(e) {
    var $sectionInput;

    if(e.type === 'keypress') {
      if(e.keyCode === 13) {
        $sectionInput = $(e.target);
      } else {
        return;
      }
    } else {
      $sectionInput = $(e.target).siblings(this.swSelectors.addInput);
    }

    var sectionTitle = $sectionInput.val();

    //add section if user input a section name
    if(sectionTitle.trim()) {

      var sections = this.getSectionArray();

      sections.push({
        sectionTitle: sectionTitle,
        sectionId:    '',
        isActive:     '1'
      });

      this.state.set({
        shopSections:   sections
      });

      $sectionInput.val("");
    }

    e.preventDefault();
  },

  onDelete: function(e) {
    var $sectionItem = $(e.target).closest(this.swSelectors.sectionItems);
    var $sectionItemActive = $sectionItem.find(this.swSelectors.sectionItemsActive);

    $sectionItemActive.val('');

    var sections = this.getSectionArray();

    this.state.set({
      shopSections:   sections
    });

    e.preventDefault();
  },

  /**
   * Repaint the list of shop sections
   */
  render: function() {
    var html = '';
    var sections = this.state.get('shopSections');
    var $container = $(this.swSelectors.sectionItemsContainer);

    _.each(sections, function (section) {
      html += shopSectionTemplate.render({
        sectionTitle: section.sectionTitle,
        sectionId: section.sectionId,
        isActive: section.isActive
      });
    }, this);

    $container.html(html);
    SW.trigger('sw-fragment-loaded', $container);
  }
});

module.exports = ShopSectionEditView;
